<template>
  <div class="columns">
    <div class="column">
      <div class="has-text-centered">
        <h1 class="title is-1">5k</h1>
        <p class="subtitle">users</p>
      </div>
    </div>
    <div class="column">
      <div class="has-text-centered">
        <h1 class="title is-1">1k</h1>
        <p class="subtitle">orders</p>          
      </div>
    </div>
    <div class="column">
      <div class="has-text-centered">
        <h1 class="title is-1">2k</h1>
        <p class="subtitle">products</p>          
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Analytics',

    props: ['city'],

    created() {
      // console.log(this.city);
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/cities/Analytics/Analytics.vue